// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1y7QH","range":"MonthRangeSwitch_range__1W3lV","disabled":"MonthRangeSwitch_disabled__2gQt7"};